import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05);
  max-height: 480px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #222;
    margin-bottom: 16px;
    margin-top: 1rem;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .card {
    border-radius: 10px;
    //background: #f7f8fc;
    padding: 16px 20px;
    //box-shadow: inset 0 0 10px #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .description {
    .name {
      font-weight: 700;
      font-size: 1rem;
      color: #374151; /* cinza escuro */
      margin-bottom: 8px;
      text-transform: capitalize;
      border-bottom: 1px solid #e5e7eb;
      padding-bottom: 6px;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-radius: 8px;
    background: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    cursor: default;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background-color: #eef2ff;
      box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
    }

    .payment-type {
      font-weight: 600;
      font-size: 0.9rem;
      color: #4f46e5; /* azul vibrante */
      flex-basis: 40%;
      text-transform: capitalize;
    }

    .total-transactions {
      font-size: 0.85rem;
      color: #6b7280; /* cinza médio */
      flex-basis: 30%;
      text-align: center;
    }

    .total-sales {
      font-weight: 700;
      font-size: 0.95rem;
      color: #111827; /* quase preto */
      flex-basis: 30%;
      text-align: right;
    }
  }

  .not-data {
    font-size: 0.8rem;
    font-weight: 600;
    color: #9ca3af;
    text-align: center;
    padding: 2rem 0;
  }
`;
